import { getGigsterProfilesReviewStatsRetrieveQueryOptions } from "@sidegigllc/api/client";
import { adminProQueryOptions } from "api/queries/admin";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { id: number };

export const reviewStatsQuery = ({ id }: QueriesInput, skillId?: number) =>
  getGigsterProfilesReviewStatsRetrieveQueryOptions(id, { skill_id: skillId });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  adminProQueryOptions(input.id),
  reviewStatsQuery(input),
];
